import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteProdutoAgricolaCadastro } from '../service';
import {
  DELETE_PRODUTO_AGRICOLA_CADASTRO,
  DELETE_PRODUTO_AGRICOLA_CADASTRO_PENDING,
  DELETE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS,
  DELETE_PRODUTO_AGRICOLA_CADASTRO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteProdutoAgricolaCadastro(action) {
  yield put({ type: DELETE_PRODUTO_AGRICOLA_CADASTRO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.PRODUTOS_AGRICOLA_EXCLUIR);

  try {
    const a = yield call(deleteProdutoAgricolaCadastro, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PRODUTO_AGRICOLA_CADASTRO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PRODUTO_AGRICOLA_CADASTRO_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se o produto não possuí lançamentos vinculados e tente novamente...');
  }
}

export default function* watchDeleteProdutoAgricolaCadastro() {
  yield takeLatest(DELETE_PRODUTO_AGRICOLA_CADASTRO, sagaDeleteProdutoAgricolaCadastro)
}
